export type StorageKey = 'accessToken' | 'branch' | 'company' | 'firebaseUser' | 'tenant' | 'tenants' | 'user' | 'redirectUrl';

export const StorageKey = {
    accessToken: 'accessToken' as StorageKey,
    branch: 'branch' as StorageKey,
    company: 'company' as StorageKey,
    firebaseUser: 'firebaseUser' as StorageKey,
    tenant: 'tenant' as StorageKey,
    tenants: 'tenants' as StorageKey,
    user: 'user' as StorageKey,
    redirectUrl: 'redirectUrl' as StorageKey,
} as const satisfies Record<StorageKey, StorageKey>;